import axios from '@/axios';

export async function getCaptationUnities(params) {
    const { data } = await axios.get(`/references/filter`, { params });

    return data.data ? data.data : data;
} 

export async function saveCaptationUnities(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/references/${id}` : '/references';
    return await axios({ method, url, data });
}
